
import collect from 'collect.js'
import Plus from '@/assets/icons/fontawesome/light/plus.svg?inline'

export default {
  components: {
    Plus,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    available: {
      type: Object,
      default: null,
    },
    active: {
      type: Object,
      default: null,
    },
    aggregator: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hotel_name: '',
      min_price: 0,
      max_price: 50000,
      rangePrice: [0, 50000],
      distance: 75,
      rangeDistance: 75,
      view_more_room_facilities: false,
      view_more_hotel_facilities: false,
    }
  },
  computed: {
    property_types() {
      let i = 0
      const propertyTypes = []
      collect(this.available?.property_types).each((value, key) => {
        propertyTypes[i] = {
          name: key,
          active: this.$route.query.property_types
            ? this.$route.query.property_types.includes(key)
            : false,
          count: value,
        }
        i++
      })
      return propertyTypes
    },
    hotel_facilities() {
      let i = 0
      const facilities = []
      collect(this.available?.hotel_facilities).each((value, key) => {
        facilities[i] = {
          name: key,
          active: this.$route.query.hotel_facilities
            ? this.$route.query.hotel_facilities.includes(key)
            : false,
          count: value,
        }
        i++
      })
      return facilities
    },
    room_facilities() {
      let i = 0
      const facilities = []
      collect(this.available?.room_facilities).each((value, key) => {
        facilities[i] = {
          name: key,
          active: this.$route.query.room_facilities
            ? this.$route.query.room_facilities.includes(key)
            : false,
          count: value,
        }
        i++
      })
      return facilities
    },
    filterStars() {
      const stars = []
      for (let i = 0; i <= 5; i++) {
        stars[i] = {
          name: i,
          active: this.$route.query.stars
            ? this.$route.query.stars.includes(i)
            : false,
          count: this.available
            ? collect(this.available.stars).has(i)
              ? this.available.stars[i]
              : 0
            : 0,
        }
      }
      return stars
    },
    filterRating() {
      let i = 0
      const ratingArray = []
      collect(this.available.rating).each((c, rating) => {
        if (parseInt(rating) >= 5 && parseInt(rating) <= 9) {
          ratingArray[i] = {
            name: parseInt(rating),
            active: this.$route.query.rating
              ? parseInt(rating) === parseInt(this.$route.query.rating)
              : false,
            count: c,
          }
          i++
        }
      })
      return ratingArray
    },
  },
  watch: {
    distance(value) {
      const query = Object.assign({}, this.$route.query)
      query.distance = value

      this.$router
        .replace({
          query: collect(query).filter().all(),
        })
        .catch(() => {})
    },
    active() {
      this.updateData()
    },
    deep: true,
  },
  mounted() {
    this.updateData()
  },
  methods: {
    updateData() {
      const query = Object.assign({}, this.$route.query)
      if (query.min_price) {
        this.rangePrice[0] = parseInt(query.min_price)
        this.min_price = parseInt(query.min_price)
        this.$refs.sliderPrice.setValue([
          this.rangePrice[0],
          this.rangePrice[1],
        ])
      } else if (!query.min_price) {
        this.rangePrice[0] = 0
        this.min_price = 0
        this.$refs.sliderPrice.setValue([0, this.rangePrice[1]])
      }
      if (query.max_price) {
        this.rangePrice[1] = parseInt(query.max_price)
        this.max_price = parseInt(query.max_price)
        this.$refs.sliderPrice.setValue([
          this.rangePrice[0],
          this.rangePrice[1],
        ])
      } else if (!query.max_price) {
        this.rangePrice[1] = 50000
        this.max_price = 50000
        this.$refs.sliderPrice.setValue([this.rangePrice[0], 50000])
      }
      if (query.distance) {
        this.rangeDistance = parseInt(query.distance)
        this.distance = parseInt(query.distance)
        this.$refs.sliderDistance.setValue(this.rangeDistance)
      } else if (!query.distance) {
        this.rangeDistance = 75
        this.distance = 75
        this.$refs.sliderDistance.setValue(75)
      }
      if (query.stars) {
        const stars = query.stars.split(',')
        for (let i = 0; i < stars.length; i++) {
          this.filterStars[stars[i]].active = true
        }
      }
      if (query.property_types) {
        const propertyTypes = query.property_types.split(',')
        for (let i = 0; i < propertyTypes.length; i++) {
          if (propertyTypes[i] === this.property_types[i].name) {
            this.property_types[i].active = true
          }
        }
      }
      if (query.hotel_name) {
        this.hotel_name = query.hotel_name
      }
    },
    searchHotelName() {
      const query = Object.assign({}, this.$route.query)
      query.hotel_name = this.hotel_name
      this.$router
        .replace({
          query: collect(query).filter().all(),
        })
        .catch(() => {})
    },
    updatePrice() {
      this.min_price = this.rangePrice[0].toFixed()
      this.max_price = this.rangePrice[1].toFixed()
      this.priceToUrl()
    },
    updatePriceRange() {
      this.rangePrice[0] = this.min_price
      this.rangePrice[1] = this.max_price
      this.$refs.sliderPrice.setValue([this.rangePrice[0], this.rangePrice[1]])
      this.priceToUrl()
    },
    updateDistance() {
      this.distance = this.rangeDistance.toFixed()
    },
    updateDistanceRange() {
      this.rangeDistance = this.distance
      this.$refs.sliderDistance.setValue(this.rangeDistance.toFixed())
    },
    starsToUrl() {
      const query = Object.assign({}, this.$route.query)
      const stars = []
      for (let i = 0; i < this.filterStars.length; i++) {
        if (this.filterStars[i].active === true) {
          stars[i] = this.filterStars[i].name
        }
      }
      const starsString = collect(stars).keys().join(',')
      if (starsString !== query.stars || !query.stars) {
        query.stars = starsString
      }
      this.$router
        .replace({
          query: collect(query).filter().all(),
        })
        .catch(() => {})
    },
    propertyTypeToUrl(event) {
      const query = Object.assign({}, this.$route.query)
      delete query.property_types
      this.$router.replace({ query }).catch(() => {})
      const collectionPropertyTypes = collect(query.property_types)
        ? collect(query.property_types)
        : ''
      for (let i = 0; i < this.property_types.length; i++) {
        if (Boolean(this.property_types[i].active) === true) {
          collectionPropertyTypes.push(this.property_types[i].name)
        }
      }
      query.property_types = collectionPropertyTypes.values().join(',')
      this.$router
        .replace({
          query: collect(query).filter().all(),
        })
        .catch(() => {})
    },
    roomFacilityToUrl() {
      const query = Object.assign({}, this.$route.query)
      delete query.room_facilities
      this.$router.replace({ query }).catch(() => {})
      const ficilitiesFilter = collect(this.room_facilities)
        .filter((value, key) => Boolean(value.active) === true)
        .all()
      query.room_facilities = collect(ficilitiesFilter).pluck('name').join(',')
      this.$router
        .replace({
          query: collect(query).filter().all(),
        })
        .catch(() => {})
    },
    hotelFacilityToUrl() {
      const query = Object.assign({}, this.$route.query)
      delete query.hotel_facilities
      this.$router.replace({ query }).catch(() => {})
      const hotelFicilitiesFilter = collect(this.hotel_facilities)
        .filter((value, key) => Boolean(value.active) === true)
        .all()
      query.hotel_facilities = collect(hotelFicilitiesFilter)
        .pluck('name')
        .join(',')
      this.$router
        .replace({
          query: collect(query).filter().all(),
        })
        .catch(() => {})
    },
    priceToUrl() {
      const query = Object.assign({}, this.$route.query)
      const minPrice = String(this.min_price)
      query.max_price = this.max_price
      query.min_price = minPrice
      this.$router
        .replace({
          query: collect(query).filter().all(),
        })
        .catch(() => {})
    },
    ratingToUrl() {
      const query = Object.assign({}, this.$route.query)
      let rating
      for (let i = 0; i < this.filterRating.length; i++) {
        if (this.filterRating[i] && this.filterRating[i].active === true) {
          if (
            !query.rating ||
            (query.rating &&
              parseInt(query.rating) !== parseInt(this.filterRating[i].name))
          ) {
            rating = this.filterRating[i].name
            break
          }
        }
      }
      query.rating = rating
      this.$router
        .replace({
          query: collect(query).filter().all(),
        })
        .catch(() => {})
    },
  },
}
